import { Box, IconButton, Text } from '@wix/design-system';
import { ChevronLeftSmall, ChevronRightSmall } from '@wix/wix-ui-icons-common';
import React, { useCallback } from 'react';
export const Pagination = _ref => {
  let {
    pageSize,
    totalItems,
    currentPageNumber,
    pagesAmount,
    onClickNext,
    onClickBack,
    formatItemsRange
  } = _ref;
  const getStartIndex = useCallback(() => {
    return currentPageNumber * pageSize + 1;
  }, [currentPageNumber, pageSize]);
  const getEndIndex = useCallback(() => {
    const endIndex = currentPageNumber * pageSize + pageSize;
    return endIndex > totalItems ? totalItems : endIndex;
  }, [currentPageNumber, pageSize, totalItems]);
  const startIndex = getStartIndex();
  const endIndex = getEndIndex();
  const isBackDisabled = currentPageNumber === 0;
  const isNextDisabled = currentPageNumber + 1 === pagesAmount;
  return /*#__PURE__*/React.createElement(Box, {
    dataHook: "pagination-container",
    verticalAlign: "space-between"
  }, /*#__PURE__*/React.createElement(Box, {
    marginTop: "4px"
  }, formatItemsRange ? formatItemsRange(startIndex, endIndex, totalItems) : /*#__PURE__*/React.createElement(Text, {
    size: "tiny"
  }, startIndex, "-", endIndex, ' ', /*#__PURE__*/React.createElement(Text, {
    size: "tiny",
    light: true,
    secondary: true
  }, "of ", totalItems))), /*#__PURE__*/React.createElement(Box, {
    gap: "9px"
  }, /*#__PURE__*/React.createElement(IconButton, {
    dataHook: "pagination-back-button",
    disabled: isBackDisabled,
    priority: "secondary",
    size: "tiny",
    skin: "standard",
    onClick: onClickBack
  }, /*#__PURE__*/React.createElement(ChevronLeftSmall, null)), /*#__PURE__*/React.createElement(IconButton, {
    dataHook: "pagination-next-button",
    disabled: isNextDisabled,
    priority: "secondary",
    size: "tiny",
    skin: "standard",
    onClick: onClickNext
  }, /*#__PURE__*/React.createElement(ChevronRightSmall, null))));
};
//# sourceMappingURL=pagination.js.map